import React, { FC } from "react";
import { Theme } from "evcharging/app/themes";
import { css } from "@emotion/css";
import useTheme from "evcharging/hooks/useTheme";
import ArrowLeftIcon from "evcharging/components/icons/ArrowLeftIcon";
import ArrowRightIcon from "evcharging/components/icons/ArrowRightIcon";
import clsx from "clsx";

interface PaginationProps {
  page: number;
  paginationCount: number;
  onChange: (page: number) => void;
}

const RatesPagination: FC<PaginationProps> = (props) => {
  const { page, paginationCount, onChange } = props;

  const theme = useTheme();
  const styles = createStyles(theme);

  let pages = new Array(paginationCount).fill(0).map((v, i) => i + 1);

  const onPage = (newPage) => () => {
    onChange(newPage);
  };

  return (
    <div className={styles.root}>
      <button
        className={styles.arrow}
        onClick={onPage(page - 1)}
        disabled={page === 1}
      >
        <ArrowLeftIcon />
      </button>
      {pages.map((p) =>
        <button
          onClick={onPage(p)}
          className={clsx(styles.button, p === page && styles.active)}
          disabled={p === page}
        >
          {p}
        </button>
      )}
      <button
        className={styles.arrow}
        onClick={onPage(page + 1)}
        disabled={page === paginationCount}
      >
        <ArrowRightIcon />
      </button>
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    display: flex;
    justify-content: center;
  `,
  button: css`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    margin-right: 10px;
    background-color: #fff;
    border: none;
    border-radius: 10px;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: #ABAFB5;
  `,
  arrow: css`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    background-color: #fff;
    border: none;
    border-radius: 10px;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: ${theme.colors.accent};
    margin-right: 15px;

    svg {
      path {
        fill: #6e7c87;
      }
    }
  `,
  active: css`
    color: #fff;
    background-color: #ABAFB5;

    svg {
      path {
        fill: #fff;
      }
    }
  `
});

export default RatesPagination;
